import { KeyboardDefinitionSchema } from '../../gen/types/KeyboardDefinition';
import corneProcyon36 from '../../assets/keyboardDefinitions/corne_procyon36.json';

/**
 * Keyboard definitions bundled directly into this Remap build, keyed by
 * "<vendorId>:<productId>" (lowercase hex, as reported by WebHID). This
 * Remap fork is dedicated to a small set of personal keyboards that will
 * never be published to the public catalog, so a matching device skips the
 * "please import a definition file" step entirely and loads straight into
 * the keymap editor.
 */
const BUNDLED_KEYBOARD_DEFINITIONS: Record<string, KeyboardDefinitionSchema> = {
  '0xafc6:0xbfc6': corneProcyon36 as KeyboardDefinitionSchema,
};

export const findBundledKeyboardDefinition = (
  vendorId: number,
  productId: number
): KeyboardDefinitionSchema | undefined => {
  const key =
    `0x${vendorId.toString(16)}:0x${productId.toString(16)}`.toLowerCase();
  return BUNDLED_KEYBOARD_DEFINITIONS[key];
};
